/**
 * Counts for the Quality report's charts: full digits where there is room ("11,940"), a
 * compact "11.9k" where a bar or column label is tight. One helper, so every chart agrees.
 */

/** Where a count switches to the compact form by default — four digits still fit a label. */
export const COMPACT_FROM = 10_000;

/** "11,940" — a whole count in the viewer's locale. */
export function formatCount(n: number): string {
  return Math.round(n).toLocaleString();
}

/**
 * "11.9k" / "1.2M" once a count reaches `from` (10,000 by default), else the full count, so a
 * tight label never truncates. One decimal, trailing ".0" dropped ("12k", not "12.0k").
 */
export function compactCount(n: number, from = COMPACT_FROM): string {
  const abs = Math.abs(n);
  if (abs < from) return formatCount(n);
  const [value, unit] = abs >= 1_000_000 ? [n / 1_000_000, 'M'] : [n / 1_000, 'k'];
  return `${value.toFixed(1).replace(/\.0$/, '')}${unit}`;
}
